/*
 * module.js - The description of the module.
 */

Fundu.Helpers.Modal = (function($) {

    // Properties
    ///////////////////////////
    var _modal = false;

    // Private Methods
    ///////////////////////////

    var selectElements = function () {
        _modal = $("#funduModal");
    };

    // Public Methods
    ///////////////////////////

    var setModalContent = function (title, content) {
        _modal.find(".modal-title").text(Fundu.Helpers.Notify.translate(title));
        _modal.find(".modal-body").html(content);
    };

    var setModalButtons = function (buttons) {
        var footer = _modal.find(".modal-footer");
        footer.html("");
        buttons.forEach(function (button) {
            var buttonElement = $('<button type="button" class="btn"></button>');
            buttonElement.text(Fundu.Helpers.Notify.translate(button.text));
            if (button.callback) { buttonElement.on('click', button.callback) }
            if (button.closeModal) {
                buttonElement.addClass("btn-gray");
                buttonElement.attr('data-dismiss', 'modal');
            } else {
                buttonElement.addClass("btn-primary");
            }
            footer.append(buttonElement);
        });
    };

    var showModal = function () {
        _modal.modal('show');
    };

    var closeModal = function () {
        _modal.modal('hide');
    };

    // Init
    ///////////////////////////
    $(function() {
        selectElements();
    });

    // Reveal public methods
    return {
        setModalContent: setModalContent,
        setModalButtons: setModalButtons,
        showModal: showModal,
        closeModal: closeModal
    };
})(jQuery);
